import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';

export const loginValidators = () => {
  const { t } = useTranslation();

  return Yup.object().shape({
    email: Yup.string()
      .required(t('validation-email-required'))
      .email(t('validation-email-invalid')),
    password: Yup.string()
      .required(t('validation-password-required'))
      .min(8, t('validation-password-min'))
      .max(32, t('validation-password-max')),
  });
};